import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  // justifyContent: 'space-between',
  flexDirection: 'column',
  margin: '16px 0px',
  height: '100%',

  '& .top-content': {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'space-between',
    // flex: 1,
    marginBottom: '12px',
    // border: '1px solid red',

    '& .title': {
      fontWeight: '500',
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      color: theme.palette.text.primary,
      letterSpacing: '0.15px',
      marginBottom: '12px',
    },

    '& .actions': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      // gap: '12px',
    },

    '& .search-container': {
      width: '44%',
      height: '36px',
      // border: '1px solid red',

      '& .MuiFormControl-root': {
        width: '100%',

        '& input': {
          padding: '6.5px 14px 6.5px 0',
        },
      },
    },

    '& button': {
      marginLeft: '12px',
      height: '36px',
      // flex: 1,

      ':first-of-type': {
        maxWidth: '170px',
        flex: 1.3,
      },
      ':last-of-type': {
        maxWidth: '120px',
        flex: 1,
      },
    },
  },

  '& .content': {
    // border: '1px solid red',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,

    '& .list': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxheight: '58px',
      height: '58px',
      padding: '0px 20px 0px 8px',
      borderRadius: theme.shape.customBorderRadius.main,

      // border: '1px solid red',

      '& .container': {
        display: 'flex',
        alignItems: 'center',

        '& .name': {
          fontSize: '14px',
          lineHeight: '18px',
          letterSpacing: '0.15px',
          color: theme.palette.text.primary,
          width: '145px',
          marginLeft: '8px',
        },
      },

      ':nth-of-type(odd)': {
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.grey[300]}`,
      },
    },

    '& .input-cont': {
      width: '100%',
    },

    '& .icon-info': {
      width: '72px',
      height: '72px',
      borderRadius: '72px',
      marginBottom: '12px',

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      fontSize: '18px',

      color: theme.palette.common.white,
      backgroundColor: theme.palette.text.secondary,

      '& svg': {
        width: '18px',
        height: '18px',
      },
    },

    '& .name-title': {
      fontWeight: '500',
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      color: theme.palette.text.primary,
      letterSpacing: '0.15px',
      marginBottom: '4px',
    },

    '& .call-waiting': {
      // border: '1px solid blue',
      display: 'flex',
      flexDirection: 'column',

      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      height: '100%',

      '& .info': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginBottom: '48px',
      },

      '& .text-info': {
        fontWeight: '500',
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        color: theme.palette.text.secondary,
        letterSpacing: '0.15px',
        marginBottom: '48px',
      },
    },

    '& .call-in-session': {
      // border: '1px solid blue',
      display: 'flex',
      flexDirection: 'column',

      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      height: '100%',

      '& .swap': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '10px',
        // border: '1px solid blue',
        marginBottom: '48px',

        '& .swap-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'column',
        },

        '& .swap-icon': {
          // display: 'flex',
          // alignItems: 'center',
          // justifyContent: 'space-between',
          // flexDirection: 'column',
          margin: '0 48px',

          '& .MuiSvgIcon-root': {
            fontSize: '48px',
            color: theme.palette.text.secondary,
          },
        },
      },

      '& .btn-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        // border: '1px solid blue',
      },
    },
  },
}))

export const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
})
